import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  DOCS: {
    id: 'Docs.docs',
    defaultMessage: 'Docs',
    description: '[Type: Label][Vis.: low] - Docs link in main navigation',
  },
});

const Docs = () => <MainNavButton href="/api/v3/" label={t(COPY.DOCS)} />;

export default Docs;
export { Docs };
